import React from "react";
import { Container } from "react-bootstrap";
import {
  FaShieldAlt,
  FaBuilding,
  FaDatabase,
  FaGavel,
  FaLock,
  FaUserShield,
  FaEnvelope,
  FaPhoneAlt,
  FaGlobe
} from "react-icons/fa";
import "./TNC.css";

const PrivacyPolicy = () => {
  return (
    <div className="tnc-container">
      <Container>
        <div className="tnc-wrapper">
          {/* Header Section */}
          <div className="tnc-header">
            {/* <div className="brand-logo">
              <span className="logo-text-white">F</span>
              <span className="logo-text-pink">T</span>
              <span className="logo-text-white">unes</span>
            </div> */}
            <h1 className="main-title">
              <span className="text-yellow">Privacy</span>{" "}
              <span className="text-pink">Policy</span>
            </h1>
            <p className="intro-text">
              At FTtunes, we are committed to protecting your personal data and
              following all applicable data protection laws and regulations.
            </p>
          </div>

          {/* Section 1 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number purple-gradient">1</span>
              <FaShieldAlt className="section-icon-inline mr-2 text-purple" />{" "}
              Our Commitment to Data Protection
            </h2>
            <p className="section-text mb-2">At FTtunes, we are committed to:</p>
            <ul className="custom-list mb-3">
              <li>Following all applicable data protection laws and regulations.</li>
              <li>
                Notifying relevant parties within 72 hours of any data breach
                that becomes known to us.
              </li>
              <li>
                Collecting only the necessary data required to carry out our
                business and fulfill the needs of our clients.
              </li>
            </ul>
            <p className="section-text mb-2">
              Please note that this policy is intended to cover the rights of
              individuals and pertains to personal data that we process. The
              rights of companies and other non-individual entities, as well as
              data not classified as personal under current law, may differ.
            </p>
            <p className="section-text">
              In many cases, FTtunes operates as a data processor on behalf of
              its clients, who are the data controllers. As a result, many of the
              legal rights and obligations relating to your personal data may
              ultimately lie with these third-party data controllers.
            </p>
          </div>

          {/* Section 2 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number orange-gradient">2</span>
              <FaBuilding className="section-icon-inline mr-2 text-orange" />{" "}
              Who We Are
            </h2>
            <div className="contact-address-box card-gradient-border transparent-bg mb-0 pb-0 border-0 shadow-none">
              <p className="section-text mb-1"><strong>Organisation:</strong> FTtunes</p>
              <p className="section-text mb-1"><strong>Contact No:</strong> +91 81780 35854</p>
              <p className="section-text mb-1"><strong>Registered Office:</strong> India-Head Office</p>
              <p className="section-text mb-0">A2, 2nd Floor, Palam Dabri Road,</p>
              <p className="section-text mb-0">Mahavir Enclave Dwarka, New Delhi - 110045</p>
            </div>
            <p className="section-text mt-3">
              Throughout this document, "we," "us," and "FTtunes" refer to
              FTtunes, the company.
            </p>
          </div>

          {/* Section 3 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number pink-gradient">3</span>
              <FaDatabase className="section-icon-inline mr-2 text-pink" />{" "}
              What Information We Collect
            </h2>
            <p className="section-text mb-2">
              As a music distribution company, we need certain information from
              you to provide our services effectively. The personal information we
              gather may include, but is not limited to the following:
            </p>
            <ul className="custom-list pink-bullets mb-0">
              <li>Your email address when you subscribe to our blog.</li>
              <li>
                Your first and last name, email address and mailing address when
                creating an account.
              </li>
              <li>
                Payment information provided when you subscribe to our services.
              </li>
              <li>
                Your language preference, subscription plan, billing information
                and promotional code, where applicable.
              </li>
              <li>
                Files, content, configuration parameters and other information you
                provide, such as photos, audio files and production preferences.
              </li>
              <li>Your contact list, if you grant us access.</li>
              <li>Your visitor profile on our website and blog.</li>
              <li>
                Your interactions with us, including emails and social media
                engagements.
              </li>
              <li>Your bank details for payments to you.</li>
            </ul>
          </div>

          {/* Section 4 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number blue-gradient">4</span>
              <FaGavel className="section-icon-inline mr-2 text-blue" />{" "}
              Legal Basis for Collecting Data
            </h2>
            <p className="section-text mb-2">
              Once we collect your data, the following legal grounds apply:
            </p>
            <div className="cards-grid-2 mt-3">
              <div className="sub-card card-gradient-border transparent-bg border-0 shadow-none p-0">
                <h3 className="text-pink font-weight-bold">Consent</h3>
                <p className="section-text text-sm">
                  We will ask for your explicit consent to use your data and will
                  explain how it will be used, such as for promotional
                  communications or newsletters.
                </p>
              </div>
              <div className="sub-card card-gradient-border transparent-bg border-0 shadow-none p-0">
                <h3 className="text-orange font-weight-bold">Contractual Obligations</h3>
                <p className="section-text text-sm">
                  We may use your data to fulfill a business relationship or
                  contract with you, such as processing payments.
                </p>
              </div>
              <div className="sub-card card-gradient-border transparent-bg border-0 shadow-none p-0">
                <h3 className="text-blue font-weight-bold">Legal Compliance</h3>
                <p className="section-text text-sm">
                  We may collect and share certain information to meet legal
                  requirements, such as tax residency information.
                </p>
              </div>
              <div className="sub-card card-gradient-border transparent-bg border-0 shadow-none p-0">
                <h3 className="text-purple font-weight-bold">Legitimate Interest</h3>
                <p className="section-text text-sm">
                  In some cases, we collect data in ways that are reasonably
                  expected as part of running our business, without significantly
                  impacting your rights. For example, we may store your IP
                  address to prevent fraud.
                </p>
              </div>
            </div>
          </div>

          {/* Section 5 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number green-gradient">5</span>
              <FaLock className="section-icon-inline mr-2 text-green" />{" "}
              Security Measures
            </h2>
            <p className="section-text mb-2">
              Protecting your data is our highest priority. Here are some of the
              measures we implement to ensure its security:
            </p>
            <ul className="custom-list green-bullets mb-0">
              <li>SSL encryption is used to secure all client systems.</li>
              <li>
                Sensitive data, such as passwords and payment details, are
                encrypted before storage on FTtunes servers.
              </li>
              <li>
                We will not share your data with third parties without your prior
                written consent, unless required by law or necessary to perform
                business activities as agreed upon with you.
              </li>
              <li>
                Data access is restricted to authorized personnel only, typically
                managed through username and password protection.
              </li>
              <li>
                All data used within FTtunes systems is stored on servers
                operated by companies that comply with current data protection
                laws.
              </li>
            </ul>
          </div>

          {/* Section 6 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number red-gradient">6</span>
              <FaUserShield className="section-icon-inline mr-2 text-red" />{" "}
              Your Rights
            </h2>
            <p className="section-text mb-2">
              As an individual, you have the following rights regarding your
              personal data:
            </p>
            <ul className="custom-list red-bullets mb-3">
              <li>
                <strong>Access:</strong> You can request access to the personal
                data we hold about you, usually free of charge.
              </li>
              <li>
                <strong>Correction:</strong> You can ask us to correct any
                inaccuracies or update incomplete information.
              </li>
              <li>
                <strong>Direct Marketing:</strong> You have the right to ask us
                to stop using your data for direct marketing activities.
              </li>
              <li>
                <strong>Consent Withdrawal:</strong> You can withdraw your
                consent for processing your data and we will cease any
                consent-based processing.
              </li>
            </ul>
            <p className="section-text mb-2">
              In many cases, FTtunes acts as a data processor on behalf of our
              clients, who are the data controllers. While we strive to
              facilitate access to, correction of, or deletion of your data, the
              ultimate legal responsibility may rest with the data controller.
            </p>
            <p className="section-text">
              Please note that even after unsubscribing from certain services, we
              may retain your details to maintain records of past interactions
              where we have a legitimate interest in doing so.
            </p>
          </div>

          {/* Section 7 - Contact Us */}
          <div className="policy-section transparent-bg mb-0 pb-0">
            <h2 className="section-title contact-title">
              <span className="section-number purple-gradient">7</span> Contact Us
            </h2>
            <p className="section-text mb-4 text-center">
              If you have any questions or concerns about how we manage your
              data, please do not hesitate to contact us.
            </p>
            <div className="contact-grid-tnc">
              <div className="contact-address-box card-gradient-border">
                <h3 className="address-title">FT Tunes</h3>
                <p className="address-line">A2, 2nd Floor, Palam Dabri Road,</p>
                <p className="address-line">Mahavir Enclave, Dwarka,</p>
                <p className="address-line">New Delhi – 110045, India</p>
              </div>
              
              <div className="contact-details-box">
                <div className="contact-item">
                  <div className="contact-icon purple-bg"><FaEnvelope /></div>
                  <div>
                    <div className="contact-label">Email</div>
                    <div className="contact-value">music@fttunes.com</div>
                  </div>
                </div>
                <div className="contact-item mt-4">
                  <div className="contact-icon red-bg"><FaGlobe /></div>
                  <div>
                    <div className="contact-label">Website</div>
                    <div className="contact-value">www.fttunes.com</div>
                  </div>
                </div>
                <div className="contact-item mt-4">
                  <div className="contact-icon orange-bg"><FaPhoneAlt /></div>
                  <div>
                    <div className="contact-label">Phone</div>
                    <div className="contact-value">+91 81780 35854</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;